import { useContext, createContext } from 'react'
import { initialState } from '../reducer/putAwayReducer'
import { actionTypes } from '../types/actionTypes'
import { ReducerPutAwayState } from '../types/reducerTypes'

interface PutAwayContext {
  state: ReducerPutAwayState
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const PutAwayContext = createContext<PutAwayContext>({
  state: initialState,
  dispatch: () => {}
})

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const usePutAway = () => {
  const context = useContext(PutAwayContext)
  if (context === undefined) {
    throw new Error('useputAway must be used within a Provider')
  }

  return context
}
